import React from 'react';

import { AirdopsHeader, KimbaDetailsHeaderItem } from './AirdropsStyled';
import { Icon, IconLock } from '../../styles/Icons';

export const KimbaDetailsHeaderDesktop = () => {
  const headersTitle = ['Token', 'Amount', 'Unlocked In', ''];
  return (
    <AirdopsHeader>
      {headersTitle.map((item: string, index: number) => {
        return (
          <KimbaDetailsHeaderItem key={index}>{item}</KimbaDetailsHeaderItem>
        );
      })}
    </AirdopsHeader>
  );
};
